import { handleDeleteConfirmation } from 'Utils/handleDelete';
import { fetchTestimonyProgram, deleteTestimonyProgram, deleteAssets } from 'Features/Learning/TestimonyProgram/Utils/TestimonyProgramUtils';
import Swal from 'sweetalert2';

/* **************************************************** */
/* CRUD TestimonyProgram                                       */
/* **************************************************** */

export const fetchTestimonyPrograms = (dispatch, filters, refatch) => {
  dispatch(fetchTestimonyProgram(filters));
};

export const handleDeleteTestimonyProgram = async (dispatch, id, setRefetch) => {
  handleDeleteConfirmation({
    dispatch,
    id,
    setRefetch,
    deleteAction: deleteTestimonyProgram,
  });
};

export const handleDeleteAssets = async (dispatch, id, setRefetch) => {
  handleDeleteConfirmation({
    dispatch,
    id,
    setRefetch,
    deleteAction: deleteAssets,
  });
};

export const handleEditTestimonyProgram = async (dispatch, item, setField, toggle) => {
  dispatch(setField({ field: 'name', value: item?.name }));
  dispatch(setField({ field: 'isUpdate', value: true }));
  dispatch(setField({ field: 'id', value: item?.id }));
  toggle();
};

export const handleGetDetailTestimonyProgram = async (dispatch, item, setDetail) => {
  dispatch(setDetail(item));
};

export const handleDetach = async (detail, setDetail, item, setField, filter, data, dispatch, attachDetachTestimonyProgram, resetState) => {
  try {
    const payload = {
      'idTryout': item.id,
      'type': item.type,
      'method': 'detach',
      'idTestimonyProgram': detail.id
    }
    // dispatch(setField({ field: 'idTryout', value: item.id }));
    // dispatch(setField({ field: 'type', value: item.type }));
    // dispatch(setField({ field: 'method', value: 'detach' }));
    // dispatch(setField({ field: 'idTestimonyProgram', value: detail.id }));
    Swal.fire({
      title: 'Apakah anda yakin?',
      text: "Anda tidak dapat mengembalikan data yang telah dihapus!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await dispatch(attachDetachTestimonyProgram(payload));
          if (response.payload === true) {
            dispatch(resetState());
            const getTestimonyProgram = await dispatch(fetchTestimonyProgram({
              ...filter,
              'filter[id]': detail.id,
              "page": 1,
            }));
            dispatch(setDetail(getTestimonyProgram.payload.data[0]));
            Swal.fire(
              'Terhapus!',
              'Data telah dihapus.',
              'success'
            )
          }
        } catch (error) {
          // Tanggapan error
          Swal.fire(
            'Gagal!',
            'Data gagal dihapus.',
            'error'
          )
          console.error('Error:', error);
          // Modal tidak akan ditutup jika terjadi kesalahan
        }
      }
    })
  } catch (error) {
    console.error("Delete error:", error);
  }

};

/* **************************************************** */
/* Pagination                                           */
/* **************************************************** */

export const handleBackPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page > 1) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page - 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleNextPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page < pagination.last_page) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page + 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleClickPagination = (page, filters, dispatch, setFilters, setRefetch) => {
  console.log(page);
  dispatch(setFilters({
    ...filters,
    page: page
  }));
  setRefetch(prevRefetch => !prevRefetch);
}